import { createAction, createSlice } from "@reduxjs/toolkit";

const getTopCategoriesSlice = createSlice({
  name: "getTopCategories",
  initialState: { data: null, success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      /* TODO: reducer for success*/
      const { data } = action.payload;
      state.data = data.data;
      state.success = true;
      state.processing = false;
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getTopCategoriesSlice;
const getTopCategoriesAction = createAction(name);

export {
  getTopCategoriesAction,
  actions as getTopCategoriesActions,
  reducer as getTopCategoriesReducer,
};
